import { type AccountTypeEnum } from "interfaces/Account";
import { type RootState } from "../globaltypes/redux";

export const isAccountTypeSelector = (state: RootState, accountType: AccountTypeEnum) =>
  state.userProfile.accountTypeId === accountType;
